/* ==========================================================================
   BUGI HOME COLLECTION - LIVE STOREFRONT LOGIC (bella-maison.js)
   - Uses live Bugi Home Collection products & images
   - Strictly filters in-stock (available === true) products
   ========================================================================== */

const defaultCart = [
  {
    id: '7601675239533',
    title: "4'lü Kombin Punch İşlemeli Dekoratif Kırlent Kılıfı Seti, Beyaz",
    variant: '4 Adet Kombin Set (Stokta)',
    price: 999.99,
    oldPrice: 1499.99,
    image: 'https://bugihomecollection.com/cdn/shop/files/1_org_zoom_8.webp?v=1738752574&width=300',
    url: '/products/4lu-kombin-punch-i%CC%87slemeli-dekoratif-kirlent-kilifi-seti-beyaz',
    qty: 1
  }
];

function getCart() {
  try {
    const saved = localStorage.getItem('bugi_cart_v1');
    return saved ? JSON.parse(saved) : defaultCart;
  } catch (e) {
    return defaultCart;
  }
}

function saveCart(cart) {
  try {
    localStorage.setItem('bugi_cart_v1', JSON.stringify(cart));
  } catch (e) {}
  renderCartUI();
}

function formatTRY(num) {
  return '₺' + Number(num || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function renderCartUI() {
  const cart = getCart();
  const totalCount = cart.reduce((acc, item) => acc + item.qty, 0);
  const totalAmount = cart.reduce((acc, item) => acc + item.price * item.qty, 0);

  document.querySelectorAll('.js-cart-count').forEach(el => {
    el.textContent = totalCount;
  });

  const itemsContainer = document.getElementById('cartDrawerItems');
  const subtotalEl = document.getElementById('cartSubtotal');
  const totalEl = document.getElementById('cartTotal');

  if (!itemsContainer) return;

  if (cart.length === 0) {
    itemsContainer.innerHTML = `
      <div style="text-align:center; padding: 48px 16px; color: var(--bm-text-muted);">
        <p style="font-weight:600; margin-bottom:8px;">Sepetinizde henüz ürün bulunmuyor.</p>
        <p style="font-size:0.82rem;">Bugi Home Collection ürünlerini keşfetmeye hemen başlayın.</p>
      </div>
    `;
  } else {
    itemsContainer.innerHTML = cart.map((item, idx) => `
      <div class="cart-item">
        <div class="cart-item-thumb" style="overflow:hidden;">
          <img src="${item.image || 'https://bugihomecollection.com/cdn/shop/files/1_org_zoom_8.webp?v=1738752574&width=200'}" alt="${item.title}" style="width:100%; height:100%; object-fit:cover; border-radius:6px;">
        </div>
        <div>
          <div class="cart-item-title">${item.title}</div>
          <div style="font-size:0.75rem; color:var(--bm-text-muted); margin-bottom:4px;">${item.variant || 'Stokta'}</div>
          <div class="cart-item-price">${formatTRY(item.price)} x ${item.qty}</div>
        </div>
        <button onclick="removeFromCart(${idx})" title="Kaldır" style="color:var(--bm-text-light); font-size:1.1rem; padding:4px;">&times;</button>
      </div>
    `).join('');
  }

  if (subtotalEl) subtotalEl.textContent = formatTRY(totalAmount);
  if (totalEl) totalEl.textContent = formatTRY(totalAmount);
}

window.removeFromCart = function(index) {
  const cart = getCart();
  cart.splice(index, 1);
  saveCart(cart);
};

window.openCartDrawer = function() {
  document.getElementById('cartDrawer')?.classList.add('open');
  document.getElementById('drawerBackdrop')?.classList.add('open');
};

window.closeCartDrawer = function() {
  document.getElementById('cartDrawer')?.classList.remove('open');
  document.getElementById('drawerBackdrop')?.classList.remove('open');
};

window.addToCartProduct = function(product) {
  const cart = getCart();
  const existing = cart.find(i => i.id === product.id && i.variant === product.variant);
  if (existing) {
    existing.qty += (product.qty || 1);
  } else {
    cart.push({
      id: product.id,
      title: product.title,
      variant: product.variant || 'Stokta',
      price: Number(product.price) || 999.99,
      image: product.image || 'https://bugihomecollection.com/cdn/shop/files/1_org_zoom_8.webp?v=1738752574&width=200',
      url: product.url || '/collections/all',
      qty: product.qty || 1
    });
  }
  saveCart(cart);
  openCartDrawer();

  // Also trigger Shopify AJAX Cart API when running on live Shopify storefront
  if (window.Shopify && product.id) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: product.id, quantity: product.qty || 1 }] })
    }).catch(() => {});
  }
};

document.addEventListener('DOMContentLoaded', () => {
  renderCartUI();

  // Mobile Menu Toggle
  const mobileBtn = document.getElementById('mobileMenuBtn');
  const headerNav = document.getElementById('headerNav');
  if (mobileBtn && headerNav) {
    mobileBtn.addEventListener('click', () => {
      headerNav.classList.toggle('mobile-open');
    });
  }

  // Wishlist heart toggle
  document.querySelectorAll('.wishlist-btn, .fav-main-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      btn.classList.toggle('active');
    });
  });

  // PDP Live Image Gallery Switcher
  const mainImg = document.getElementById('pdpMainImage');
  const thumbs = document.querySelectorAll('.pdp-thumb');
  if (mainImg && thumbs.length > 0) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const newSrc = thumb.dataset.imgSrc;
        if (newSrc) {
          mainImg.src = newSrc;
        }
      });
    });
  }

  // PDP Pack/Set Selector
  const packBtns = document.querySelectorAll('.pack-btn');
  const regularPriceEl = document.getElementById('pdpRegularPrice');
  const oldPriceEl = document.getElementById('pdpOldPrice');
  const campaignPriceEl = document.getElementById('pdpCampaignPrice');
  const selectedPackLabel = document.getElementById('selectedPackLabel');
  let currentPackMultiplier = 1;
  let currentPackName = "4'lü Kombin Set (Standart)";

  packBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      packBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      currentPackMultiplier = parseInt(btn.dataset.multiplier || '1', 10);
      currentPackName = btn.dataset.packname || "4'lü Kombin Set (Standart)";
      const discountFactor = currentPackMultiplier === 2 ? 0.96 : 1;

      const oldVal = 1499.99 * currentPackMultiplier;
      const regVal = 999.99 * currentPackMultiplier * discountFactor;

      if (oldPriceEl) oldPriceEl.textContent = formatTRY(oldVal);
      if (regularPriceEl) regularPriceEl.textContent = formatTRY(regVal);
      if (campaignPriceEl) campaignPriceEl.textContent = formatTRY(regVal);
      if (selectedPackLabel) selectedPackLabel.textContent = currentPackName;
    });
  });

  // PDP Quantity Control
  const qtyInput = document.getElementById('pdpQtyInput');
  const qtyMinus = document.getElementById('pdpQtyMinus');
  const qtyPlus = document.getElementById('pdpQtyPlus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      qtyInput.value = v;
    });
    qtyPlus.addEventListener('click', () => {
      const v = Math.min(24, parseInt(qtyInput.value || '1', 10) + 1);
      qtyInput.value = v;
    });
  }

  // PDP Main Add to Cart Button
  const mainAddBtn = document.getElementById('pdpAddToCartBtn');
  if (mainAddBtn) {
    mainAddBtn.addEventListener('click', () => {
      const qty = parseInt(qtyInput?.value || '1', 10);
      const basePrice = parseFloat(mainAddBtn.dataset.productPrice || '999.99');
      const discountFactor = currentPackMultiplier === 2 ? 0.96 : 1;
      const unitPrice = +(basePrice * currentPackMultiplier * discountFactor).toFixed(2);
      addToCartProduct({
        id: mainAddBtn.dataset.productId || '7601675239533',
        title: mainAddBtn.dataset.productTitle || "4'lü Kombin Punch İşlemeli Dekoratif Kırlent Kılıfı Seti, Beyaz",
        variant: currentPackName,
        price: unitPrice,
        image: mainAddBtn.dataset.productImage || 'https://bugihomecollection.com/cdn/shop/files/1_org_zoom_8.webp?v=1738752574&width=300',
        qty
      });
    });
  }

  // Accordions
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      item?.classList.toggle('open');
    });
  });

  // Announcement Bar Ticker
  const tickerSlides = document.querySelectorAll('#bmAnnouncementTicker .announcement-slide');
  if (tickerSlides.length > 1) {
    let current = 0;
    setInterval(() => {
      tickerSlides[current].classList.add('is-hidden');
      current = (current + 1) % tickerSlides.length;
      tickerSlides[current].classList.remove('is-hidden');
    }, 4500);
  }
});
